import { Yup, type YupTypes, inputFileSchema } from "@pharmupp/p3-front-commons"
import type { NewsEventRubricsName } from "../../../../../commons"
import type { LabOrExternChoice } from "../../../../../core"

export const schema = Yup.object({
  publishLater: Yup.boolean(),
  publicationDate: Yup.date()
    .when("$isCreate", ([isCreate], schemaRef) =>
      isCreate
        ? schemaRef.min(new Date(), "La date de début ne peut être dans le passé")
        : schemaRef,
    )
    .when("publishLater", ([publishNow]: boolean[], schemaRef) =>
      publishNow === true ? schemaRef.required() : schemaRef,
    ),
  cancellationReason: Yup.string(),
  rubric: Yup.string<NewsEventRubricsName>().required(),
  labOrExtern: Yup.string<LabOrExternChoice>().when("rubric", {
    is: (rubric: NewsEventRubricsName) => rubric === "LAB_EXTERN",
    then: (schema) => schema.required(),
    otherwise: (schema) => schema,
  }),
  laboratoryId: Yup.number().when(["rubric", "labOrExtern"], {
    is: (rubric: NewsEventRubricsName, labOrExtern: LabOrExternChoice) =>
      rubric === "LAB_EXTERN" && labOrExtern === "laboratory",
    then: (schema) => schema.required(),
    otherwise: (schema) => schema,
  }),
  solutionId: Yup.number().when(["rubric", "labOrExtern"], {
    is: (rubric: NewsEventRubricsName, labOrExtern: LabOrExternChoice) =>
      rubric === "LAB_EXTERN" && labOrExtern === "solution",
    then: (schema) => schema.required(),
    otherwise: (schema) => schema,
  }),
  title: Yup.string().max(100).required(),
  image: inputFileSchema.default(undefined).notRequired(),
  description: Yup.string().required(),
  restrictedUppIds: Yup.array().of(Yup.number().required()),
})

export type GeneralInfosValues = YupTypes.InferType<typeof schema>
